// extracted by mini-css-extract-plugin
export default {"iconWrapper":"index-module__iconWrapper___ORXSq","icon":"index-module__icon___vcXi3"};